// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1Pcf4","clinicsSelect":"TableHeading_clinicsSelect__2muzQ"};